function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 .066h16v16H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 .066v4h4v-4H0zm6 0v4h4v-4H6zm6 4v-4h4v4h-4zm-12 2v4h4v-4H0zm6 4v-4h4v4H6zm6-4v4h4v-4h-4zm-12 10v-4h4v4H0zm6-4v4h4v-4H6zm6 4v-4h4v4h-4z",
  fill: "#fff"
});

var SvgShortcuts = function SvgShortcuts(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' y='0.065918' width='16' height='16' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 0.065918V4.06592H4V0.065918H0ZM6 0.065918V4.06592H10V0.065918H6ZM12 4.06592V0.065918H16V4.06592H12ZM0 6.06592V10.0659H4V6.06592H0ZM6 10.0659V6.06592H10V10.0659H6ZM12 6.06592V10.0659H16V6.06592H12ZM0 16.0659V12.0659H4V16.0659H0ZM6 12.0659V16.0659H10V12.0659H6ZM12 16.0659V12.0659H16V16.0659H12Z' fill='white'/%3E %3C/svg%3E";
export { SvgShortcuts as ReactComponent };